<template lang="pug">
  .contacts.has-text-centered
    .contacts-wrap
      .office
        .title {{ gettext('Head Office in Denmark') }}
        table.main
          tr
            td
              p.txt {{ gettext('Email')+':' }}
            td
              p.bold
                a.mail(href="mailto:info@bixter.com") info@bixter.com
          tr
            td
              p.txt {{ gettext('Phone')+':' }}
            td
              p.bold
                a.phone(href="tel:+4571747504") +45 71 74 7504
          tr
            td

      contact-form

      <!--#map-->
        <!--GmapMap(-->
        <!--ref="googleMap"-->
        <!--:center="coordinates[0]"-->
        <!--:options="{disableDefaultUI: true}"-->
        <!--map-type-id="roadmap"-->
        <!--:zoom="16"-->
        <!--style="width: 100%; height: 100%"-->
        <!--)-->
          <!--GmapMarker(-->
          <!--:icon="'../../assets/images/icons/icon-map.png'"-->
          <!--:position="coordinates[0]"-->
          <!--:title="'Bixter'"-->
          <!--)-->
          <!--GmapRectangle(-->
          <!--:bounds="{north: -90, east: 180, south: 90, west: -180}"-->
          <!--:options="{fillColor: '#000', fillOpacity: 0.1}"-->
          <!--)-->

</template>

<script>

import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import { getEnv } from '@/services/Utils'
import { GOOGLE_API_KEY } from '@/constants'
import ContactForm from '../search/workers/parts/contact-form'
import mixin from '@/mixins'

Vue.use(VueGoogleMaps, {
  load: {
    key: getEnv.GOOGLE_MAPS_API_KEY || GOOGLE_API_KEY
  }
})
export default {
  name: 'Contacts',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  components: {
    ContactForm
  },
  data () {
    return {
      active: false,
      markers: {},
      coordinates: [
        {
          locations: 'Denmark',
          lat: 55.4806127,
          lng: 8.5635362
        }
      ]
    }
  },
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: gettext('Contacts'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/contacts/index.vue